import SEO from "@/components/site/SEO";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import ServiceCards from "@/components/site/ServiceCards";
import TrustBand from "@/components/site/TrustBand";
import CTASection from "@/components/site/CTASection";
import Footer from "@/components/site/Footer";
import Testimonials from "@/components/site/Testimonials";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5EFE0] grain" data-testid="landing-root">
      <SEO
        title="Líneas Doradas · Transporte Turístico en Bogotá y Colombia"
        description="Transporte turístico premium en van, buseta y bus desde Bogotá hacia toda Colombia. Traslados aeropuerto, tours, rutas empresariales y escolares. Cotiza ya."
      />
      <Header />
      <main>
        <Hero />
        <ServiceCards />
        <TrustBand />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
